import React from 'react';
import { HeatmapV2 } from '../../../../../../../../Components/HeatmapV2';
import { EmptyState } from '../../../../../../../../Packages/EmptyState';
import GraphLoader from '../../../../../../../../Components/ContentLoaders/GraphLoader';

const BenchmarkHeatmap = (props) => {
    let columns = props.fetchRaterHeatmapApi.data != null && props.fetchRaterHeatmapApi.data.columns ? props.fetchRaterHeatmapApi.data.columns : []
    let data = props.fetchRaterHeatmapApi.data != null && props.fetchRaterHeatmapApi.data.data ? props.fetchRaterHeatmapApi.data.data : []

    return (
        <div className='cardwrapper'>
            <h3>Heatmap</h3>
            <p className='description-container'>This heatmap shows the mean score by category, sub-category, behavior across the feedback provider groups.</p>
            {
                props.fetchRaterHeatmapApi.isProcessing ? <GraphLoader height={300} width={600} /> :
                    (props.fetchRaterHeatmapApi.error && props.fetchRaterHeatmapApi.data === null) || (props.fetchRaterHeatmapApi.data != null && props.fetchRaterHeatmapApi.data.columns && props.fetchRaterHeatmapApi.data.columns === 0) ?
                        < EmptyState emptyStateMessage="No data found" /> :
                        <HeatmapV2
                            isMultipleSheetsNeeded={true}
                            isHeaderSectionHidden={true}
                            id="heatmap-grid"
                            heatmapType={"Overall Heatmap'"}
                            columns={columns}
                            childColumns={columns}
                            headers={[]}
                            selectedHeaders={[]}
                            data={data
                            }
                            onSelectHeader={() => { }}
                            showHeadersLoader={false}
                            showTableLoader={
                                false
                            }
                            showErrorState={
                                false
                            }
                            onExpand={() => { }}
                            selectedScoreLevel={["favourable"]}
                            scoreLevelList={[]}
                            onChangeScoreType={(value) => { }}
                            comparisonLevelList={[]}
                            selectedLevel={[]}
                            onChangeComparisonLevel={() => { }}
                        />
            }
        </div>
    );
};

export default BenchmarkHeatmap;





